import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { getISQQuestions, updateISQ } from '../shared/_api'
import { investQueryKeyRoot, useInvestDataState } from './_investDataState'

const getIsqQueryKey = (investmentId?: string) => ['isq', investmentId] as const

export const useIsqDataState = () => {
  const { data: investData } = useInvestDataState()

  return useQuery({
    queryKey: getIsqQueryKey(investData?.investment?.id),
    queryFn: async () => {
      const data = await getISQQuestions(investData?.investment?.id)
      return {
        ...data,
      }
    },
    enabled:
      !!investData?.investment &&
      investData?.investment_state?.qualification === 'required',
    staleTime: Infinity,
  })
}

export const useMutateISQ = () => {
  const { data: investData } = useInvestDataState()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['isq'],
    mutationFn: async (data: Record<string, unknown>) => {
      const res = await updateISQ(investData?.investment?.id, data)
      return res
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: investQueryKeyRoot })
    },
  })
}
